// Account/view scope is metadata, never proof of authorization. The server owns access checks.
const params = new URLSearchParams(
  typeof window === 'undefined' ? self.name : window.location.search,
);
export const MANAGED_SCOPE = params.get('scope') || '';
export const MANAGED_VIEW_ID = params.get('viewId') || '';
export const MANAGED_ACCOUNT_ID = params.get('accountId') || '';
if (typeof window !== 'undefined' && ![MANAGED_SCOPE, MANAGED_VIEW_ID, MANAGED_ACCOUNT_ID].every((value) => (
  /^[a-zA-Z0-9:_-]{1,240}$/.test(value)
))) {
  throw new Error('Managed Telegram view scope is required');
}
export const MANAGED_STORAGE_SCOPE = MANAGED_VIEW_ID
  ? `spiritide:${MANAGED_SCOPE}:${MANAGED_ACCOUNT_ID}:${MANAGED_VIEW_ID}`
  : `spiritide:auxiliary:${crypto.randomUUID()}`;
